module.exports = __webpack_public_path__ + "static/media/alarm-snooze.171456b4.svg";